<template></template>
<script>
    export default {
        props: ['version'],
        mounted() {
            // alert(this.version);
            let versions = {
                v1: '//ourreviews.today/embed/v4/146411249789488/3/2404199026',
                v2: '//ourreviews.today/embed/v4/146411249789488/8/2511708679'
            }
            
            let scriptTag = document.createElement('script');

            scriptTag.setAttribute('src', versions[this.version])
            document.head.appendChild(scriptTag);
        }
    }    
</script>